import React, { ReactNode } from 'react';
import { CartProvider } from './CartContext';
import { CepProvider } from './CepContext';
import { FeeProvider } from './FeeContext';

interface ProvidersProps {
  children: ReactNode;
}

const Providers: React.FC<ProvidersProps> = ({ children }) => {
  return (
    <CartProvider>
      <CepProvider>
        <FeeProvider>
          {children}
        </FeeProvider>
      </CepProvider>
    </CartProvider>
  );
};

export default Providers;
